export default (api) => {

    const getPaymentModes = ({ amount, paymentType, gateway } = {}) => {
        return api.post("/api/v1/payment-modes", { amount, paymentType, gateway });
    };

    return { getPaymentModes };
};
